/**
 * Builder UI — English in englishBuilderLabels.js; Danish here; sv/no in nordicBuilderLabels.js.
 * Missing keys fall back to English (default).
 */

import { en } from './englishBuilderLabels.js';
import { sv, no } from './nordicBuilderLabels.js';

const da = {
  widgetBuilder: 'Widget-bygger',
  languageSection: 'Sprog',
  interfaceLanguage: 'Builder-sprog',
  interfaceLanguageHint: 'Menuer, knapper, tekster og widget på din side.',
  configure: 'Konfigurer',
  preview: 'Forhåndsvisning',
  embed: 'Indlejring',
  myWidgets: 'Mine widgets',
  savedCount: '{count} gemt',
  newWidget: '+ Ny widget',
  noSavedYet: 'Ingen gemte widgets endnu. Konfigurer nedenfor — gemmes automatisk.',
  newDraft: 'Nyt udkast — ændringer gemmes automatisk.',
  delete: 'Slet',
  deleteConfirm: 'Slet denne gemte widget?',
  untitled: 'Uden titel',
  changesInstant: 'Ændringer opdaterer forhåndsvisningen med det samme.',
  saving: 'Gemmer…',
  unsavedChanges: 'Ugemte ændringer…',
  saveError: 'Kunne ikke gemme til skyen. Genstart API-serveren og prøv igen.',
  savedCloud: 'Gemt i databasen.',
  savedLocal: 'Gemt lokalt (database offline).',
  autoSaved: 'Auto-gemt {time}',
  changesAutoSave: 'Ændringer gemmes automatisk.',
  saveNow: 'Gem nu',
  widgetId: 'ID',
  widgetName: 'Widget-navn',
  widgetType: 'Widget-type',
  widgetLanguage: 'Widget-sprog (indlejring)',
  widgetLanguageHint: 'Sprog som besøgende ser i widgetten. Rediger i src/i18n/widgetLabels.js',
  theme: 'Tema',
  themeRequired: 'Påkrævet ved oprettelse; bevares i indlejring.',
  themeLight: 'Lys',
  themeDark: 'Mørk',
  allowedDomains: 'Tilladte domæner (indlejring)',
  allowedDomainsHint:
    'Et domæne per linje. Tom = alle sider. localhost er altid tilladt i dev.',
  domainsPlaceholder: 'eksempel.dk\nwww.minblog.dk',
  accentColor: 'Accentfarve',
  hintTeamInjuries:
    'Brug hold-dropdown over forhåndsvisningen: vælg Alle hold for liste per klub, eller ét hold.',
  hintTeamPlayerList:
    'Vælg et hold i Team-dropdown over forhåndsvisningen for fuld trup med detaljer.',
  hintTeamProfile: 'Vælg et hold i Team-dropdown over forhåndsvisningen.',
  hintPlayerPicker: 'Vælg en spiller i Player-dropdown over forhåndsvisningen.',
  hintSelectMatchBar:
    'Vælg en kamp i Match-dropdown i bjælken ovenfor (ved siden af Turnering). Auto vælger den bedste tilgængelige kamp.',
  competition: 'Turnering',
  player: 'Spiller',
  team: 'Hold',
  match: 'Kamp',
  groupFeatured: 'Udvalgte',
  groupAllLeagues: 'Alle ligaer',
  groupSelection: 'Valg',
  groupDefault: 'Standard',
  groupPlayers: 'Spillere',
  groupClubs: 'Klubber i ligaen',
  groupLive: 'Live',
  groupFinishedLineups: 'Afsluttet — med holdopstillinger',
  groupFinished: 'Afsluttet',
  groupUpcoming: 'Kommende',
  matchAuto: 'Auto (seneste / bedst tilgængelig)',
  matchAutoSub: 'Vælger live, derefter seneste afsluttede kamp med data',
  topScorer: 'Topscorer',
  teamAllGrouped: 'Alle hold (grupperet per klub)',
  teamFirstInTable: 'Første i tabellen',
  hintTeamInjuriesPicker:
    'Alle hold viser hver klub separat; vælg én klub for kun deres skadede spillere',
  hintTeamPlayerListPicker: 'Vælg en klub for at vise hele truppen med detaljer',
  hintTeamProfilePicker: 'Vælg en klub til holdprofil-widgetten',
  hintPlayerPickerBar: 'Vælg en spiller til profil-widgetten',
  searchCompetitions: 'Søg turneringer…',
  searchPlayers: 'Søg spillere…',
  searchTeams: 'Søg hold…',
  searchMatches: 'Søg kampe…',
  noCompetitions: 'Ingen turneringer fundet',
  noPlayer: 'Ingen spiller fundet',
  noTeam: 'Intet hold fundet',
  noMatches: 'Ingen kampe matcher søgningen',
  loadingLeagues: 'Henter ligaer…',
  competitionsFilter: '{count} turneringer — skriv for at filtrere',
  loadingFixtures: 'Henter kampe fra sæsonprogram…',
  previewSelectedOnly: 'Forhåndsvisning viser kun valgt kamp',
  matchesPick: '{count} kampe — vælg runde (holdopstillinger når tilgængelige)',
  noFixturesAuto: 'Ingen kampe listet — auto-valgt kamp bruges',
  loading: 'Indlæser…',
  competitionsCount: '{count} turneringer',
  embedCode: 'Indlejringskode',
  embedIntro: 'Kopiér og indsæt i din sides HTML.',
  embedThemeNote:
    'Tema: {theme}. Domæne-whitelist under Konfigurer styrer hvor embed må loades.',
  copied: 'Kopieret!',
  copyEmbed: 'Kopiér indlejringskode',
  openLiveEmbed: 'Åbn live embed-side',
  openEmbedTest: 'Åbn embed-testside',
  embedDevNote: 'Dev: URL bruger localhost. Script-fane loader /embed.js.',
  embedWidgetId: 'Widget-ID',
  tabIframe: 'Iframe',
  tabScript: 'Script',
  cat_match: 'Kamp',
  cat_live: 'Live & program',
  cat_league: 'Ligatabel',
  cat_team: 'Hold',
  cat_player: 'Spiller',
  cat_stats: 'Spillerstatistik',
  wt_match_card_label: 'Kampkort',
  wt_match_card_desc: 'Resultat, stadion, mål, kort, trænere',
  wt_match_info_label: 'Kampinfo',
  wt_match_info_desc: 'Stadion, tilskuere, dommer, trænere',
  wt_goals_list_label: 'Målliste',
  wt_goals_list_desc: 'Målscorere for valgt kamp',
  wt_match_events_label: 'Kamphændelser',
  wt_match_events_desc: 'Mål, kort, udskiftninger, VAR',
  wt_lineups_label: 'Holdopstillinger',
  wt_lineups_desc: 'Formationer, XI, kort, udskiftninger',
  wt_coach_card_label: 'Trænerkort',
  wt_coach_card_desc: 'Hovedtrænere for en kamp',
  wt_live_scores_label: 'Livescore',
  wt_live_scores_desc: 'Live, kommende og resultater',
  wt_live_matches_label: 'Live nu',
  wt_live_matches_desc: 'Kun kampe i gang',
  wt_fixtures_label: 'Program',
  wt_fixtures_desc: 'Kommende kickoff',
  wt_results_label: 'Resultater',
  wt_results_desc: 'Afsluttede kampe',
  wt_standings_label: 'Stilling',
  wt_standings_desc: 'Samlet, hjemme og ude',
  wt_group_standings_label: 'Gruppeturnering',
  wt_group_standings_desc: 'Gruppespil',
  wt_form_guide_label: 'Formguide',
  wt_form_guide_desc: 'Seneste form per hold',
  wt_team_stats_label: 'Mål for/imod',
  wt_team_stats_desc: 'Angreb og forsvar fra tabellen',
  wt_team_list_label: 'Holdliste',
  wt_team_list_desc: 'Alle klubber med placering og kvalifikation',
  wt_team_profile_label: 'Holdprofil',
  wt_team_profile_desc: 'Ét hold — statistik, form, europæiske pladser',
  wt_player_list_label: 'Spillerliste',
  wt_player_list_desc: 'Fuld trup — alder, nationalitet, position og statistik',
  wt_player_profile_label: 'Spillerprofil',
  wt_player_profile_desc: 'Én spiller — mål, assists, kampe',
  wt_top_scorers_label: 'Topscorere',
  wt_top_scorers_desc: 'Målrangliste',
  wt_top_assists_label: 'Top assists',
  wt_top_assists_desc: 'Assistrangliste',
  wt_appearances_label: 'Kampe',
  wt_appearances_desc: 'Flest kampe spillet',
  wt_minutes_label: 'Minutter',
  wt_minutes_desc: 'Flest minutter på banen',
  wt_discipline_label: 'Kort',
  wt_discipline_desc: 'Gule og røde kort',
  wt_injuries_label: 'Skader',
  wt_injuries_desc: 'Spillere markeret som skadede',
};

const translations = { en, da, sv, no };

function applyVars(text, vars) {
  if (!vars) return text;
  let s = text;
  for (const [k, v] of Object.entries(vars)) {
    s = s.split(`{${k}}`).join(String(v));
  }
  return s;
}

export function getBuilderLabels(locale = 'en') {
  const dict = translations[locale] || {};
  const fallback = translations.en;
  return (key, vars) => applyVars(dict[key] ?? fallback[key] ?? key, vars);
}

/** Widget type label/description keys from widget id slug. */
export function widgetTypeLabelKey(typeId) {
  return `wt_${typeId.replace(/-/g, '_')}_label`;
}

export function widgetTypeDescKey(typeId) {
  return `wt_${typeId.replace(/-/g, '_')}_desc`;
}
